export const EMPTY_SEARCH_FORM = {
  orderNumber: "",
  customerOrderNumber: "",
  itemCode: "",
  shipFirstName: "",
  shipLastName: "",
  orderStatus: "",
  orderType: "",
  startMonth: "",
  startDay: "",
  startYear: "",
  endMonth: "",
  endDay: "",
  endYear: "",
};

export const ORDER_STATUS_OPTIONS = [
  { value: "Open", label: "Open" },
  { value: "In Process", label: "In Process" },
  { value: "On Hold", label: "On Hold" },
  { value: "Back Ordered", label: "Back Ordered" },
  { value: "Shipped", label: "Shipped" },
  { value: "Cancelled", label: "Cancelled" },
  { value: "Closed", label: "Closed" },
];

export const ORDER_TYPE_OPTIONS = [
  { value: "Standard", label: "Standard" },
  { value: "Quick Order", label: "Quick Order" },
  { value: "Sample", label: "Sample" },
  { value: "Stock Transfer", label: "Stock Transfer" },
  { value: "Trade Show", label: "Trade Show" },
  { value: "Miscellaneous", label: "Miscellaneous" },
];

export const MONTH_OPTIONS = [
  { value: "1", label: "January" },
  { value: "2", label: "February" },
  { value: "3", label: "March" },
  { value: "4", label: "April" },
  { value: "5", label: "May" },
  { value: "6", label: "June" },
  { value: "7", label: "July" },
  { value: "8", label: "August" },
  { value: "9", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

export function getYearOptions(span = 15) {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: span }, (_, index) => {
    const year = String(currentYear - index);
    return { value: year, label: year };
  });
}

export function getDaysInMonth(month, year) {
  if (!month) return 31;
  const numericYear = year ? Number(year) : 2000;
  return new Date(numericYear, Number(month), 0).getDate();
}

export const EMPTY_DATE = "00/00/0000";

export function composeDate(month, day, year) {
  if (!month || !day || !year) return EMPTY_DATE;
  return `${String(month).padStart(2, "0")}/${String(day).padStart(2, "0")}/${year}`;
}

export function buildCustomFulfillmentSearchPayload(form, auth = {}, page = 1) {
  return {
    orderNumber: (form.orderNumber || "").trim(),
    itemCode: (form.itemCode || "").trim(),
    shipFirstName: (form.shipFirstName || "").trim(),
    shipLastName: (form.shipLastName || "").trim(),
    orderStartDate: composeDate(form.startMonth, form.startDay, form.startYear),
    orderEndDate: composeDate(form.endMonth, form.endDay, form.endYear),
    companyDivId: String(auth.companyDivId || ""),
    compDivIdForLegacyOrders: String(auth.clientId || ""),
    page: String(page),
    pageSize: "10",
    sortBy: "created_on",
    sortDirection: "desc",
    isDelinquentOrderSearch: false,
    appIds: [],
    customerOrderNumber: (form.customerOrderNumber || "").trim(),
  };
}

function formatOrderDate(value) {
  if (!value) return "";
  const date = new Date(Number(value));
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString();
}

function formatShipAddress(order = {}, details = {}) {
  return [
    order.shipAddress1 || details.shipToAddress1,
    order.shipAddress2 || details.shipToAddress2,
    order.shipAddress3 || details.shipToAddress3,
    order.shipToCity || details.shipToCity,
    order.shipToState || details.shipToState,
    order.shipToZipCode || details.shipToZipCode,
  ]
    .filter(Boolean)
    .join(", ");
}

export function normalizeOrderResult(row) {
  const order = row?.order || row || {};
  const details = row?.orderDetails || {};
  const items = (order.items?.length ? order.items : details.allItems) || [];
  const itemList = items.length ? items : [{}];
  const shipAddress = formatShipAddress(order, details);

  return itemList.map((item, itemIndex) => ({
    rowKey: `${order.orderPlacementId || order.orderNumber || "order"}-${
      item.id || item.orderEntryLineId || itemIndex
    }`,
    orderEntryId: order.orderEntryId || order.orderPlacementId,
    orderPlacementId: order.orderPlacementId,
    orderNumber: order.orderNumber || details.orderNumber || "",
    customerOrderNumber:
      order.customerOrderNumber || details.customerOrderNumber || "",
    itemCode: item.itemNumber || "",
    shipFirstName: order.shipFirstName || details.shipToFirstName || "",
    shipLastName: order.shipLastName || details.shipToLastName || "",
    shipAddress,
    status: order.status || details.currentOrderStatus || "",
    orderType: order.orderType || details.orderType || "",
    createdOn: formatOrderDate(order.createdOn || details.orderedDate),
    companyNumber: details.companyNumber || "",
  }));
}

export function extractSearchResults(response) {
  const rows = Array.isArray(response?.orderResult) ? response.orderResult : [];
  return rows.flatMap(normalizeOrderResult);
}

/** Maps API status to Action dropdown value when results load. */
export function getRowActionForStatus(status) {
  const normalized = String(status || "").trim().toUpperCase();
  if (normalized === "CANCEL") {
    return "Cancel";
  }
  if (normalized === "SHIPPED") {
    return "Shipped";
  }
  return "";
}

export function buildInitialRowActions(results) {
  return results.reduce((acc, order) => {
    const action = getRowActionForStatus(order.status);
    if (action) {
      acc[order.rowKey] = action;
    }
    return acc;
  }, {});
}

export function buildFulfillmentPushPayload(
  row,
  { currentOrderStatus, orderComment, companyNumber, trackingNumbers }
) {
  return {
    orderEntryId: Number(row.orderEntryId),
    orderNumber: row.orderNumber,
    customerOrderNumber: row.customerOrderNumber,
    currentOrderStatus,
    orderComment,
    companyNumber: row.companyNumber || companyNumber || "",
    trackingNumbers: trackingNumbers || "",
  };
}
